// extracted by mini-css-extract-plugin
export var parent = "styles-module--parent--dd068";
export var pulse = "styles-module--pulse--1cbac";